/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    // 2026-05-18 WS_FIX_CART_DRAWER_REFRESH
    // Original path (cart-form.refreshFromHtml) threw TypeError on custom drawer
    // because its internal mergeListItems couldn't find expected DOM target.
    // Brute replace: parse fresh section HTML, swap drawer innerHTML.
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      if (newDrawer) {
        this.innerHTML = newDrawer.innerHTML;
      } else {
        const newForm = doc.querySelector('cart-form');
        if (newForm) {
          const oldForm = this.querySelector('cart-form');
          if (oldForm) oldForm.replaceWith(newForm);
        }
      }
      this.dispatchEvent(new CustomEvent('on:cart:after-merge', { bubbles: true }));
    } catch (e) {
      console.error('[WS] updateFromCartChange brute-swap failed:', e);
    }
  }
}

window.customElements.define('cart-drawer', CartDrawer);
